"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeatmapDescriptor = void 0;
var tslib_1 = require("tslib");
var PluggableHeatmap_1 = require("./PluggableHeatmap");
var BigChartDescriptor_1 = require("../BigChartDescriptor");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var ImplicitDrillDownHelper_1 = require("../../../utils/ImplicitDrillDownHelper");
var drillDownUtil_1 = require("../drillDownUtil");
var HeatmapDescriptor = /** @class */ (function (_super) {
    tslib_1.__extends(HeatmapDescriptor, _super);
    function HeatmapDescriptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeatmapDescriptor.prototype.getFactory = function () {
        return function (params) { return new PluggableHeatmap_1.PluggableHeatmap(params); };
    };
    HeatmapDescriptor.prototype.applyDrillDown = function (insight, drillDownContext) {
        var withFilters = this.addFilters(insight, drillDownContext.drillDefinition, drillDownContext.event);
        return drillDownUtil_1.modifyBucketsAttributesForDrillDown(withFilters, drillDownContext.drillDefinition);
    };
    HeatmapDescriptor.prototype.addFilters = function (source, drillConfig, event) {
        var clicked = ImplicitDrillDownHelper_1.drillDownFromAttributeLocalId(drillConfig);
        var cutIntersection = (event.drillContext.intersection || []).filter(function (i) {
            return sdk_ui_1.isDrillIntersectionAttributeItem(i.header) &&
                i.header.attributeHeader.localIdentifier === clicked;
        });
        return drillDownUtil_1.addIntersectionFiltersToInsight(source, cutIntersection);
    };
    return HeatmapDescriptor;
}(BigChartDescriptor_1.BigChartDescriptor));
exports.HeatmapDescriptor = HeatmapDescriptor;
//# sourceMappingURL=HeatmapDescriptor.js.map